import { useEffect } from 'react';

import { useAuth } from '@workos-inc/authkit-react';

import { useGetOrganizationByIdQuery } from '@/store/api/organization';
import { captureAsyncError } from '@/utils/captureAsyncError';

export const StoreOrgId = () => {
  const { organizationId, switchToOrganization } = useAuth();
  const { data: orgIdFromBackend } = useGetOrganizationByIdQuery(undefined, {
    skip: Boolean(organizationId),
  });

  useEffect(() => {
    if (!organizationId && orgIdFromBackend?.orgId) {
      void switchToOrganization({
        organizationId: orgIdFromBackend.orgId,
      }).catch(captureAsyncError);
    }
  }, [organizationId, orgIdFromBackend?.orgId, switchToOrganization]);

  return null;
};
